// pkg84 — public legal pages (PRE-PILOT GATE): /terms and /privacy render the official documents from src/content/legalContent.js (single source — the signup checkbox links here and terms_version stamps against the same TERMS_VERSION). Unauthenticated by design; simple print-friendly layout; minimal **bold** inline rendering (ALL-CAPS warranty/liability sections preserved verbatim) — delivered 2026-07-15

import React from 'react';
import { Link } from 'react-router-dom';
import { TERMS, PRIVACY, EFFECTIVE_DATE } from '../content/legalContent';

const NAVY = '#1E2761';
const NAVY_DEEP = '#0F1838';

// Minimal inline renderer: the only markup in the content is **bold**.
function renderInline(text) {
  const parts = String(text || '').split('**');
  return parts.map((chunk, i) => (i % 2 === 1
    ? <strong key={i} style={{ color: NAVY_DEEP }}>{chunk}</strong>
    : <React.Fragment key={i}>{chunk}</React.Fragment>));
}

function LegalDoc({ doc, other }) {
  return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      <div style={{ maxWidth: 780, margin: '0 auto', padding: '40px 22px 80px', fontFamily: 'Georgia, serif', color: '#222', lineHeight: 1.65 }}>
        <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, marginBottom: 26 }}>
          <Link to="/login" style={{ color: NAVY, marginRight: 16 }}>LawMighty</Link>
          <Link to={other.path} style={{ color: NAVY }}>{other.label}</Link>
        </div>
        <h1 style={{ fontFamily: 'Arial, sans-serif', color: NAVY_DEEP, fontSize: 26, margin: '0 0 6px' }}>{doc.title}</h1>
        <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, color: '#777', margin: '0 0 26px' }}>Effective {EFFECTIVE_DATE}</p>
        {doc.intro.map((p, i) => (
          <p key={`i${i}`} style={{ fontSize: 15.5, margin: '0 0 14px' }}>{renderInline(p)}</p>
        ))}
        {doc.sections.map((s, si) => (
          <section key={si}>
            <h2 style={{ fontFamily: 'Arial, sans-serif', color: NAVY, fontSize: 17, margin: '26px 0 10px' }}>{s.heading}</h2>
            {s.paras.map((p, pi) => p.kind === 'bullet' ? (
              <p key={pi} style={{ fontSize: 15.5, margin: '0 0 10px 22px', textIndent: -14 }}>•&nbsp;&nbsp;{renderInline(p.text)}</p>
            ) : (
              <p key={pi} style={{ fontSize: 15.5, margin: '0 0 12px' }}>{renderInline(p.text)}</p>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
}

export function TermsPage() {
  return <LegalDoc doc={TERMS} other={{ path: '/privacy', label: 'Privacy Policy' }} />;
}

export function PrivacyPage() {
  return <LegalDoc doc={PRIVACY} other={{ path: '/terms', label: 'Terms of Service' }} />;
}
